import React from 'react';
import hiring from '../assets/img/tech-guy-ipad-code-small.jpg';
import logo from '../assets/img/logo.png';
import solutions from '../assets/img/binary-roots-small.jpg';
import Headline from '../shared/headlines';
import fire from '../firebase/firebase';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homeSummary: null,
      homeHeadingOne: null,
      homeHeadingOneSummary: null,
      homeHeadingOneSummaryLink: null,
      homeHeadingTwo: null,
      homeHeadingTwoSummary: null,
      homeHeadingTwoSummaryLink: null
     };
  }

  componentDidMount() {

    let homeSummary = fire.database().ref('home-summary');
    let homeHeadingOne = fire.database().ref('home-heading1');
    let homeHeadingOneSummary = fire.database().ref('home-heading1-summary');
    let homeHeadingOneSummaryLink = fire.database().ref('home-heading1-summary-link');
    let homeHeadingTwo = fire.database().ref('home-heading2');
    let homeHeadingTwoSummary = fire.database().ref('home-heading2-summary');
    let homeHeadingTwoSummaryLink = fire.database().ref('home-heading2-summary-link');


    homeSummary.on('value', snapshot => {
      this.setState({homeSummary: snapshot.val()});
    });
    homeHeadingOne.on('value', snapshot => {
      this.setState({homeHeadingOne: snapshot.val()});
    });
    homeHeadingOneSummary.on('value', snapshot => {
      this.setState({homeHeadingOneSummary: snapshot.val()});
    });
    homeHeadingOneSummaryLink.on('value', snapshot => {
      this.setState({homeHeadingOneSummaryLink: snapshot.val()});
    });
    homeHeadingTwo.on('value', snapshot => {
      this.setState({homeHeadingTwo: snapshot.val()});
    });
    homeHeadingTwoSummary.on('value', snapshot => {
      this.setState({homeHeadingTwoSummary: snapshot.val()});
    });
    homeHeadingTwoSummaryLink.on('value', snapshot => {
      this.setState({homeHeadingTwoSummaryLink: snapshot.val()});
    });
  }

  render() {
    return (
      <div className="app-main-container">
          <div className="block-image-header">
              <div className="block-image-header__content block__content">
              <div className="app-content">
                <h1>We are <img src={logo} className="app-logo" alt="eitx-logo" /></h1>
                {/* eslint-disable-next-line */}
                <div dangerouslySetInnerHTML={{__html: this.state.homeSummary}}>
                </div>
                </div>
              </div>
          </div>

        <div className="parallax__short"></div>

        <div className="section-container__grey">
          <div className="app-content main-content">
            <Headline 
            title={this.state.homeHeadingOne}
            link={this.state.homeHeadingOneSummaryLink}
            summary={this.state.homeHeadingOneSummary}
            imgside="left"
            img={solutions} />
            

            <Headline 
            title={this.state.homeHeadingTwo}
            link={this.state.homeHeadingTwoSummaryLink}
            summary={this.state.homeHeadingTwoSummary}
            imgside="right"
            img={hiring} />
          </div>
        </div>
      </div>
    )
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/home.js